import { combineReducers } from "redux";
import { lopReducer } from "./lopReducer";
import { ngayNghiReducer } from "./ngayNghiReducer";
import { trangThaiDangKyAnReducer } from "./trangThaiDangKyAnReducer";

export const danhMucReducerWrapper = combineReducers({
  
    lop: lopReducer,
    ngayNghi: ngayNghiReducer,
    trangThaiDangKyAn: trangThaiDangKyAnReducer,
  
})